<div class="c-cms-form">
    <div class="form-flex">
        <div class="form-label">{{if field.required == 1}}<span class="form-required">*</span>{{/if}}{{field.displayName}}</div>
        <div class="form-value">
            <div class="form-row u-pt8">
                {{each field.listOptions}}
                <div class="form-row">
                    <label class="c-form-checkbox">
                        <input type="checkbox" name={{field.fieldName}}
                               onchange="$sk.changeCHECKBOX(this, {{$value.optionId}}, '{{field.fieldName}}')"
                               {{$value.checked ? 'checked' : ''}}
                               {{$value.disabled ? 'disabled' : ''}} />
                        <span class="checkbox-icons"></span>
                        <span class="checkbox-text">{{$value.optionValue}}</span>
                        {{if $value.otherisFillIn == 1}}
                        <input type="text" class="checkbox-other" value="{{$value.otherValue}}" onchange="$sk.changeListOtherValue(this, {{$value.optionId}}, '{{field.fieldName}}')" />
                        {{/if}}
                    </label>
                    {{if $value.checked && $value.dirty && $value.otherisFillIn == 1 && $value.otherIsRequire == 1 && !$value.otherValue}}
                    <div class="form-error">请填写</div>
                    {{/if}}
                </div>
                {{/each}}
            </div>
            {{if field.dirty && field.invalid}}
            <div class="form-error">{{field.validationMessage}}</div>
            {{/if}}
        </div>
    </div>
</div>